import { styled } from '@mui/system'
import Box from '@mui/material/Box'

const TasksPageBox = styled(Box)`
	padding: 2.5rem 2rem;
	min-height: 100%;
	max-height: 100%;
	overflow: hidden;
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
`

export { TasksPageBox }
